import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function makeStripePayment(user_id, amount) {
  try {

    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("amount", amount);

    const response = await axios.post(
      apiBaseUrl+"stripe1/makePayment",
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    return response.data;

  } catch (error) {

    console.error("makeStripePayment error:", error);

    return {
      status: 0,
      type: "error",
      success: "Failed to initiate Stripe payment"
    };
  }
}

export async function makePaypalPayment(user_id, amount) {
  try {

    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("amount", amount);

    const response = await axios.post(
      apiBaseUrl+"paypal1/makePayment",
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    return response.data;

  } catch (error) {

    console.error("makeStripePayment error:", error);

    return {
      status: 0,
      type: "error",
      success: "Failed to initiate Stripe payment"
    };
  }
}